<template>
  <v-main>
    <AppBar extension-height="50px"/>
    <v-layout fill-height column id="mainLayout">
      <v-container flex-fill fluid>
        <div class="purchase-title pb-9" v-if="purchaseType==='01'">
          <div>
            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">티켓</span>{{ productData.goodsNm }}
            </div>
            <div class="secondary--text mt-2">{{ productData.goodsDscrt }}</div>
            <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ saleAmt - productData.dcAmt | comma }}원</div>
          </div>
        </div>
        <div class="purchase-title pb-9" v-if="purchaseType==='02'">
          <div class="d-flex flex-column">
            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">물성</span>{{ productData.goodsNm }}
            </div>
            <div class="fs-16 fw-700 primary--text">{{ saleAmt| comma }} C</div>
          </div>
          <div class="image">
            <v-img :src="$downUrl(this.imgs[0])"></v-img>
          </div>
        </div>

        <hr class="hr"/>
        <div class="purchase-info py-9">
          <div class="info-list">
            <div class="list-title">주문자 정보</div>
            <ul>
              <li>{{ userData.userName }}</li>
              <li>{{ userData.mobileNo }}</li>
              <li>{{ userData.email }}</li>
            </ul>
          </div>
          <div class="info-list" v-if="purchaseType==='02' && userData.daNo===null">
            <div class="list-title">배송지 정보
              <v-btn plain :ripple="false" class="btn" @click="movePageBtn()">추가</v-btn>
            </div>
            <ul>
              <li>
                배송지 정보가 없습니다.<br/>추가해주세요.
              </li>
            </ul>
          </div>
          <div class="info-list" v-if="purchaseType==='02' && userData.daNo!==null">
            <div class="list-title">배송지 정보
              <v-btn plain :ripple="false" class="btn" @click="movePageBtn()">변경</v-btn>
            </div>
            <ul>
              <li>{{ userData.recipient }}</li>
              <li>{{ userData.deliveryMobileNo }}</li>
              <li>{{ userData.addressFirst }}</li>
              <li>{{ userData.addressSecond }}</li>
            </ul>
          </div>
          <div class="info-list mb-10" v-if="purchaseType==='02' && userData.daNo!==null">
            <div class="list-title">공동현관 출입방법</div>
            <ul>
              <li v-text="userData.enterMethodCd"></li>
              <li v-text="userData.enterMethodMemo"></li>
            </ul>
          </div>
          <div class="info-list" v-if="purchaseType==='02' && userData.daNo!==null">
            <div class="list-title">배송시 요청사항</div>
            <ul>
              <li v-text="userData.requestCd"></li>
              <li v-text="userData.requestMemo"></li>
            </ul>
          </div>
        </div>

        <template v-if="purchaseType==='02'">
          <hr class="hr"/>
          <div class="coin py-9">
          <div class="list-title mb-2">코인 사용</div>
          <div class="d-flex justify-space-between align-center">
            <span>총 보유 코인</span>
            <strong>{{ initAmountCoin|comma }}C</strong>
          </div>
          <div class="d-flex justify-space-between align-center mt-5">
            <span class="mr-12 flex-shrink-0">사용</span>
            <div class="input-group">
              <v-text-field solo flat filled
                            hide-details="true"
                            v-model="useCoin"
                            required
                            class="text-right"
                            placeholder="0"
              />
              <v-btn depressed :ripple="false" color="primary" class="btn-input" width="90"
                     @click="useTotalCoin">전액사용
              </v-btn>
            </div>
          </div>
        </div>
        </template>

        <template v-if="purchaseType==='01'">
          <hr class="hr"/>
          <div class="py-4">
            <div class="list-title">쿠폰 정보</div>
            <div class="input-group">
              <v-text-field append-icon="mdi-menu-down" solo flat v-model="couponTypeNm" readonly
                            placeholder="쿠폰 정보" @click="couponRollerPickerOpen"/>
            </div>
          </div>
        </template>

        <hr class="hr"/>
        <div class="py-4">
          <div class="list-title">결제 방법</div>
          <div class="input-group">
            <v-text-field append-icon="mdi-menu-down" solo flat v-model="paymentTypeNm" readonly
                          placeholder="결제 방법" @click="purchaseRollerPickerOpen"/>
          </div>
        </div>

        <template v-if="purchaseType==='01'">
          <hr class="hr"/>
          <div class="py-9">
          <div class="list-title">결제 정보</div>
          <v-divider class="my-4"></v-divider>
          <div class="d-flex flex-column gap-2 mb-5">
            <div class="d-flex justify-space-between gray200--text fw-500">결제금액</div>
            <dl class="payment">
              <dt>
                상품금액
              </dt>
              <dd>
                {{ saleAmt - productData.dcAmt | comma }}원
              </dd>
            </dl>
            <dl class="payment">

              <dt>
                쿠폰할인금액
              </dt>
              <dd>
                -{{ couponAmt | comma }}원
              </dd>
            </dl>
          </div>
          <div class="d-flex justify-space-between align-center fs-16">
            <strong class="blueGrayDarken4--text">총 결제금액</strong>
            <strong class="primary--text">{{ realPayAmt | comma }}원</strong>
          </div>
        </div>
        </template>

        <template v-if="purchaseType==='02'">
          <hr class="hr"/>
          <div class="py-9">
            <div class="list-title">결제 정보</div>
            <v-divider class="my-4"></v-divider>
            <div class="d-flex flex-column gap-2 mb-5">
              <div class="d-flex justify-space-between gray200--text fw-500">결제금액</div>
              <dl class="payment">
                <dt>
                  물성리워드상품
                </dt>
                <dd>
                  {{ (saleAmt - productData.dcAmt) + 'C' | comma }}
                </dd>
              </dl>
              <dl class="payment">
                <dt>
                  배송비
                </dt>
                <dd>
                  3,000원
                </dd>
              </dl>
            </div>
            <div class="d-flex flex-column gap-2 mb-5">
              <!-- <div class="d-flex justify-space-between gray200--text fw-500">할인금액 <strong class="primary--text">0원</strong></div> -->
              <dl class="payment">
                <dt>코인사용</dt>
                <dd>{{ useCoin == '' ? '0C' : useCoin + 'C' | comma }}</dd>
              </dl>
            </div>
            <div class="d-flex justify-space-between align-center fs-16">
              <strong class="blueGrayDarken4--text">총 결제금액</strong>
              <strong class="primary--text">3,000원</strong>
            </div>
          </div>
        </template>

        <hr class="hr"/>
        <div class="py-4">
          <p class="fs-12 fw-500">위 주문의 상품 및 결제,주문정보 내용을 확인하였으며 결제에 동의합니다.</p>
          <div class="d-flex flex-column">
            <v-btn text plain :ripple="false" class="btn-agree" @click="termsDetailsOpen(4)">개인정보 수집 동의<img
                :src="getImage('ic_arrow_right.svg')"/></v-btn>
            <v-btn text plain :ripple="false" class="btn-agree" @click="termsDetailsOpen(5)">개인정보 제공 동의<img
                :src="getImage('ic_arrow_right.svg')"/></v-btn>
          </div>
        </div>
      </v-container>
      <v-footer app color="white" fixed class="content-footer">
        <div class="footer-btns">
          <BlackBtn x-large @click="on_pay" :disabled="isDisabled" str="구매하기"/>
        </div>
      </v-footer>
    </v-layout>
    <TermsDetailsModal :dialog="termsDetailsDialog" :name="userData.userName" :flag="termsFlag"
                       @close="termsDetailsDialog = false"/>

    <SelectRollerPicker ref="purchaseRollerPicker" @selectValue="purchaseSelectValue"/>
    <SelectRollerPicker ref="couponRollerPicker" @selectValue="couponSelectValue"/>
    <DeliveryAddressContainerModal ref="DeliveryAddressContainerModal" :name="userData.userName"
                                   :mobileNo="userData.mobileNo" :daNo="userData.daNo" @callback="findAddressDetail"/>

    <form name="mobileweb" id="mobileweb" method="post" class="mt-5" accept-charset="euc-kr">
      <input type="hidden" name="P_INI_PAYMENT" v-bind:value="paymentTypeCd">
      <input type="hidden" name="P_MID" value="ezwelmind1">
      <!-- <input type="hidden" name="P_MID" value="INIpayTest"> -->
      <input type="hidden" name="P_OID" value="mobile_test1234">
      <input type="hidden" name="P_AMT" v-bind:value="realPayAmt">
      <input type="hidden" name="P_GOODS" v-bind:value="productData.goodsNm">
      <input type="hidden" name="P_UMANE" v-bind:value="userData.userName">
      <input type="hidden" name="P_MOBILE" v-bind:value="userData.mobileNo">
      <input type="hidden" name="P_EMAIL" v-bind:value="userData.email">
      <input type="hidden" name="P_NOTI" v-bind:value="goodsNo+','+userData.userKey+','+ordNo+','+cpNo">
      <input type="hidden" name="P_NEXT_URL" v-bind:value="baseURL+'/user/order/complete'">
      <input type="hidden" name="P_CHARSET" value="utf8">
      <input type="hidden" name="P_QUOTABASE" value="12">
      <input type="hidden" name="P_RESERVED" value="below1000=Y&vbank_receipt=N">
    </form>
  </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import DeliveryAddressContainerModal from "@/components/layout/DeliveryAddressContainerModal.vue";
import store from '@/store'
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import TermsDetailsModal from "@/components/terms/TermsDetailsModal";

const VUE_APP_API_BASE_URL = 'http://localhost:8181'
const VUE_APP_API_BASE_DEV_URL = 'https://dms.happymint.dev'
const VUE_APP_API_BASE_PRD_URL = 'https://dms.happymint.kr'

let baseURL = ''
let loc = window.location.host
if (loc.includes('localhost')) baseURL = `${VUE_APP_API_BASE_URL}`
// if (loc.includes('localhost')) baseURL = `${VUE_APP_API_BASE_DEV_URL}`
else if (loc.includes('happymint.dev')) baseURL = `${VUE_APP_API_BASE_DEV_URL}`
else if (loc.includes('happymint.kr')) baseURL = `${VUE_APP_API_BASE_PRD_URL}`

export default {
  data: () => ({
    coin: '',
    goodsNo: null,
    purchaseType: null,
    useCoin: '',
    initAmountCoin: 0,
    initUseCoin: 0,
    realPayAmt: 0,
    saleAmt: 0,
    isDisabled:false,
    userData: {
      userName: '',
      email: '',
      mobileNo: '',
      amountCoin: 0,
      daNo: null,
      deliveryMobileNo: null
    },
    productData: {
      goodsNm: null
    },
    priceCoin: 0,
    baseURL: "",
    items: [
      "계좌이체",
      "카드결제",
      "선택"
    ],
    couponItems: [

    ],
    couponData: null,
    selectFlag: 0,
    couponSelectFlag: 0,
    paymentTypeNm: null,
    paymentTypeCd: null,
    couponTypeNm: null,
    couponTypeCd: null,
    couponAmt: 0,
    cpNo: 0,
    imgs: [],
    termsDetailsDialog: false,
    termsFlag: null
  }),
  components: {
    BlackBtn,
    DeliveryAddressContainerModal,
    SelectRollerPicker,
    TermsDetailsModal
  },
  watch: {
    useCoin() {
      if (typeof (this.useCoin) !== "number") {
        this.useCoin = this.useCoin.replace(/[^0-9]/g, '');
      }

      if (Number(this.initAmountCoin) < this.useCoin) {
        this.$alert("보유코인보다 더 큰 금액을 입력하였습니다.");
        this.userData.amountCoin = this.initAmountCoin;
        this.useCoin = 0
        return this.useCoin;
      }
      this.userData.amountCoin = this.initAmountCoin - this.useCoin;
      return this.useCoin = String(this.useCoin).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/^0/g, '');
    }
  },
  created() {

  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  async mounted() {
    this.baseURL = baseURL
    if (this.$route.query.goodsNo != undefined) {
      this.goodsNo = this.$route.query.goodsNo
      this.purchaseDetail();
    } else {
      this.goodsNo = this.$route.params.goodsNo
    }
  },
  methods: {
    termsDetailsOpen(index) {
      this.termsFlag = index;
      this.termsDetailsDialog = true;
    },
    movePageBtn() {
      this.$refs.DeliveryAddressContainerModal.open();
    },
    //구매정보
    async purchaseDetail() {
      await store.dispatch('purchaseDetail', this.$_payload({goodsNo: this.goodsNo}))
        .then(res => {
          console.log(res)
          this.productData = res.data.pdGoods;
          // console.log("this.productData : ",this.productData)
          if (this.productData.atchNoLists != null) {
            this.imgs = this.productData.atchFileNameLists;
            // console.log("this.imgs : ",this.imgs)
          }
          this.userData = res.data.dmsUserPurchaseInfoResult;
          this.purchaseType = this.productData.goodsClsf;
          this.saleAmt = this.productData.saleAmt;
          this.initAmountCoin = this.userData.amountCoin;
          //상품 타입에 따라 배송비 결제금액 배송비
          if (this.purchaseType === '01') {
            this.realPayAmt = this.productData.saleAmt - this.productData.dcAmt;
          }
          if (this.purchaseType === '02') {
            this.realPayAmt = 3000
          }

          this.getPurchaseCoupons();

        })
        .catch(error => {
          console.error(error)

        })
        .finally(() => {

        })
    },
    //이니시스 연동
    on_pay() {
      if (this.userData.daNo == null && this.purchaseType == '02') {
        this.$alert('배송지정보를 등록해주세요');
        return false;
      }
      if (this.purchaseType === '02') {
        if (this.productData.saleAmt > this.useCoin.replace(/[^0-9]/g, '')) {
          this.$alert('코인사용 금액이 부족합니다.');
          return false;
        }

        if (this.productData.saleAmt < this.useCoin.replace(/[^0-9]/g, '')) {
          this.$alert('코인사용 금액이 결제 금액 보다 큽니다');
          return false;
        }
      }
      if (this.paymentTypeNm === null || this.paymentTypeNm === "선택") {
        this.$alert('결제 방법을 선택해 주세요.');
        return false;
      }


      let myform = document.querySelector('mobileweb')
      myform = document.mobileweb;
      myform.action = "https://mobile.inicis.com/smart/payment/";
      myform.target = "_self";
      myform.submit();
    },
    //배송지정보 조회
    async findAddressDetail() {
      await store.dispatch('deliveryAddress', this.$_payload('so', {}))
        .then(res => {
          if (res.data !== null) {

            // 배송지의 모바일 번호가 사용자의 모바일에 들어가는등 데이터 꼬임 각각 넣어줌
            // this.userData = res.data

            console.log("findAddressDetail : ", res.data)
            this.userData.deliveryMobileNo = res.data.mobileNo;
            this.userData.addressFirst = res.data.addressFirst;
            this.userData.addressSecond = res.data.addressSecond;
            this.userData.daNo = res.data.daNo;
            this.userData.enterMethodCd = res.data.enterMethodCd;
            this.userData.enterMethodMemo = res.data.enterMethodMemo;
            this.userData.recipient = res.data.recipient;
            this.userData.requestCd = res.data.requestCd;
            this.userData.requestMemo = res.data.requestMemo;
            console.log("userData : ", this.userData)

          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {

        })
    },
    //코인 전액 사용
    useTotalCoin() {
      let checkPrice = this.userData.amountCoin - this.productData.saleAmt;
      if (0 > checkPrice) {
        this.$alert("보유코인이 부족합니다.");
        return false;
      }

      this.userData.amountCoin = this.initAmountCoin - this.productData.saleAmt;
      this.useCoin = this.productData.saleAmt;

    },
    purchaseRollerPickerOpen() {
      this.selectFlag = 1;
      this.$refs.purchaseRollerPicker.setFlicking(this.items);
    },
    couponRollerPickerOpen() {
      if (this.couponData.length == 0) {
        this.$alert("보유한 쿠폰이 없습니다.");
        return false;
      }
      this.couponSelectFlag = 1;
      this.$refs.couponRollerPicker.setFlicking(this.couponItems);
    },
    purchaseSelectValue(value) {
      this.$nextTick(() => {
        if (this.selectFlag === 1) {
          this.paymentTypeNm = value;
          if (value === "카드결제") {
            this.paymentTypeCd = "Card"
          }
          if (value === "계좌이체") {
            this.paymentTypeCd = "Bank"
          }
        }
        this.selectFlag = 0;
      })
    },
    couponSelectValue(value) {
      this.$nextTick(() => {
        if (this.couponSelectFlag === 1) {
          this.couponTypeNm = value;
          for (let i = 0; i < this.couponData.length; i++) {
            let data = this.couponData[i];

            if(data.cpNo != null){
                this.cpNo = data.cpNo;
            }

            if(value === "선택"){
                this.realPayAmt = this.productData.saleAmt - this.productData.dcAmt
                this.couponAmt  = 0;
                this.cpNo = 0;
                this.isDisabled = false;
            }
            if(value !== "선택"){
                if (value === data.cpNm) {
                    if (data.dcGb === "할인금액") {
                        this.couponAmt = data.dcAmt;
                        this.realPayAmt = (this.productData.saleAmt - this.productData.dcAmt)
                        this.realPayAmt -= data.dcAmt;
                    } else {
                        this.couponAmt = this.saleAmt * (data.dcRate / 100);
                        if (this.couponAmt > data.maxDcAmt) {
                        this.couponAmt = data.maxDcAmt;
                        }
                        this.realPayAmt = (this.productData.saleAmt - this.productData.dcAmt)
                        this.realPayAmt -= this.couponAmt;
                    }
                }

                if(this.realPayAmt <= 0){
                  this.isDisabled = true;
                }
            }


          }
        }
        if (this.realPayAmt < 0) {
          this.realPayAmt = 0;
        }
        this.couponSelectFlag = 0;
      })
    },
    async getPurchaseCoupons() {
      await store.dispatch('getPurchaseCoupons', this.$_payload({goodsNo: this.goodsNo}))
        .then(res => {
          this.couponData = res.data;
          console.log(":::::::", this.couponData);
          for (let i = 0; i < this.couponData.length; i++) {
            let data = this.couponData[i];
            this.couponItems.push(data.cpNm);
          }
          this.couponItems.push("선택");
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {

        })
    }
  }
}
</script>
<style lang="scss" scoped>
.purchase-title {
  display: flex;
  justify-content: space-between;

  .title {
    display: flex;
    align-items: center;
    font-size: 18px !important;
    font-weight: 700;
  }

  .badge {
    border: 1px solid var(--v-primary-base);
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: var(--v-primary-base);
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
  }

  .image {
    width: 122px;
    height: 118px;
    border-radius: 4px;
    overflow: hidden;
  }
}

.purchase-info {
  display: flex;
  flex-direction: column;
  gap: 40px;

  .info-list {
    display: flex;
    flex-direction: column;

    ul {
      display: flex;
      flex-direction: column;
      gap: 5px;

      li {
        line-height: 22px;
        color: #101010;
      }
    }
  }
}

.list-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 10px;

  .v-btn.btn {
    background: $color-sub;
    border-radius: 20px;
    color: var(--v-primary-base);
    font-size: 12px;
    font-weight: 400;
    height: 22px;
    padding: 0 12px;
    min-width: 20px;

  }
}

.v-item-group.v-bottom-navigation .footer-btns {
  border-top: 1px solid #F0F0F0;
  padding-top: 12px;
}

.payment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;

  dt {
    color: #B1B1B1;
  }

  dd {
    color: #9FA3A8;
    font-weight: 500;
  }
}

.v-btn.btn-agree {
  justify-content: space-between;
  color: #808080;
  padding-left: 0;
  padding-right: 0;
  font-size: 14px;
  font-weight: 400;
}

.text-right::v-deep input {
  text-align: right;
}
</style>
